export const documentStatus = [
  'รอตรวจเอกสาร',
  'ผ่านการตรวจสอบ',
  'ดำเนินการออกบัตร',
  'ดำเนินการเสร็จสิ้น',
  'ยกเลิก'
];


export const documentPaymentStatus = [
  '-',
  'รอชำระเงิน',
  'ชำระเงินเสร็จสิ้น',
  'ไม่ผ่านการตรวจสอบ',
  'รอตรวจสอบยอดชำระ',
  'ยกเลิกการชำระ'
];